export default __webpack_public_path__ + "static/media/list_empty.7e85bfcd.png";